
import helper from '../../helper'

const formatter =
{
    setupCustomFields: (fields) => {
        // simple select
        fields
            .filter((x) => x.type == "select")
            .forEach((x) => {
                x.selectOptions = {
                    noneSelectedText: x.placeholder,
                };
            });

        // multi select
        fields
            .filter((x) => x.type == "vueMultiSelect")
            .forEach((x) => {
                delete x.max;
                x.selectOptions = {
                    multiple: true,
                    key: "id",
                    label: "name",
                    searchable: true,
                    closeOnSelect: false,
                    allowEmpty: !x.required,
                    trackBy: "id",
                    taggable: true,
                    hideSelected: true,
                };
            });

        // cleave
        fields
            .filter((x) => x.type == "cleave")
            .forEach((x) => {
                x.cleaveOptions = {
                    numeral: true,
                    delimiter: ",",
                    numeralThousandsGroupStyle: "thousand",
                };
            });
    },

    reformModelAfterGet: (model, fields, moduleName) => {
        let newModel = {};

        newModel.Medias = model.medias;

        for (const key in model) {
            const newKey = helper.toPascalCase(key);
            const field = fields.find((x) => x.model == newKey);

            if (!field)
                continue;

            switch (field.type) {
                case "tag":
                    newModel[newKey] = model[key] ? model[key].split(",") : [];
                    break;
                case "cleave":
                    newModel[newKey] = model[key].toLocaleString();
                    break;
                case "vueMultiSelect":
                    newModel[newKey] = model[key].map(item => {
                        // remove id and primary side of junction and keep secondary side
                        // for example in [ArticleInCategory] table just keep articleCategoryId value 
                        // and convert it to array to fill multio select drop down
                        delete item.id;
                        delete item[helper.toCamelCase(moduleName) + 'Id'];
                        const id = item[Object.keys(item)[0]];
                        return {
                            id: id.toString(),
                            name: field.values.find(v => v.id == id).name
                        }
                    });
                    break;
                case "table": {
                    field.tableValues.map(item => {
                        let tableValue = null;
                        item.Value = "";

                        // if already have some feature value, use them to set value
                        if (model[key] && model[key].length) {
                            tableValue = model[key].find(x => x[helper.toCamelCase(field.refEntity) + "Id"] == item.Id);
                            if (tableValue) {
                                item.Value = tableValue.value;
                            }
                        }
                        item[field.refEntity + "Id"] = item.Id;
                        delete item.Id;
                        item[moduleName + "Id"] = model.id;

                    })
                    newModel[newKey] = field.tableValues;
                    break;
                }

                default:
                    newModel[newKey] = model[key];
                    break;
            }

        }

        return newModel;
    },


    reformModelBeforePost: (model, schema) => {

        let newModel = {};

        for (const key in model) {

            const field = schema.fields.find((x) => x.model == key);

            if (!field)
                continue;

            let val = model[key];

            if (field.type == "cleave" && val)
                val = parseFloat(val.replace(/,/g, ""));

            else if (field.type == "tag" && val)
                val = val.join(",");

            else if (field.dataType == "int" || field.dataType == "int?" ||
                field.dataType == "long" || field.dataType == "long?" ||
                field.dataType == "float" || field.dataType == "float?" ||
                field.dataType == "double" || field.dataType == "double?")
                val = parseFloat(val);

            else if (field.dataType == "array" && field.type == "vueMultiSelect")
                val = val.map(x => ({ id: parseFloat(x.id) }));

            else if (field.dataType == "objectsArray" && field.type == "table") {
                console.log(val);
            }

            newModel[helper.toCamelCase(key)] = val;
        }

        return newModel;
    }

}
export default formatter;